<template>
    <div>
        <el-card>
            <el-form :inline="true">
                <el-form-item label="状态">
                    <el-select v-model="queryCondition.status">
                        <el-option v-for="item in transferStatus" :key="item.code" :label="item.desc"
                                   :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分发显示状态">
                    <el-select v-model="queryCondition.businessType">
                        <el-option v-for="item in distributes" :key="item.code" :label="item.desc"
                                   :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="币种">
                    <el-input v-model="queryCondition.coinType" placeholder="请输币种" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="时间区间：">
                    <el-date-picker v-model="queryCondition.time" type="datetimerange" range-separator="至"
                                    start-placeholder="开始时间" end-placeholder="结束时间" ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="pageNo = 1,submitQuery()">查询</el-button>
                    <el-button type="primary" @click="exportInfo()">导出数据</el-button>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="showBusinessType" style="margin-left: 150px;">余额变更种类显示</el-checkbox>
                </el-form-item>
            </el-form>
        </el-card>

        <el-table :data="transferInfo">
            <el-table-column prop="id" label="分组" align="center"></el-table-column>
            <el-table-column prop="businessType" label="余额变更种类" v-if="showBusinessType"
                             align="center"></el-table-column>
            <el-table-column prop="userId" label="用户Id" align="center"></el-table-column>
            <el-table-column prop="coinType" label="币种" align="center"></el-table-column>
            <el-table-column prop="availableBalanceChange" label="可用余额" align="center"></el-table-column>
            <el-table-column prop="frozenBalanceChange" label="冻结余额" align="center"></el-table-column>
            <el-table-column prop="time" label="时间" align="center"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    import api from './api';

    export default {
        name: "transferShiZhiQuery",
        data() {
            return {
                transferInfo: [],
                queryCondition: {
                    status: '',
                    businessType: '',
                    coinType: '',
                    time: [],
                    startTime: '',
                    endTime: ''
                },
                transferStatus: [
                    {code: 0, desc: '成功'},
                    {code: 1, desc: '等待执行'},
                    {code: 2, desc: '执行中'},
                    {code: 3, desc: '失败'}
                ],
                distributes: [{code: 'DISTRIBUTE', desc: '显示'}, {code: 'DISTRIBUTE_VISIBLE', desc: '隐藏'}],
                showBusinessType: false
            }
        },
        methods: {
            submitQuery() {
                this.queryCondition.startTime = this.queryCondition.time[0];
                this.queryCondition.endTime = this.queryCondition.time[1];
                if (this.queryCondition.startTime == null || this.queryCondition.startTime == "") {
                    this.$message.info("请设置开始时间");
                    return;
                }
                if (this.queryCondition.endTime == null || this.queryCondition.endTime == "") {
                    this.$message.info("请设置结束时间");
                    return;
                }
                this.queryTransferList(this.queryCondition);
            },
            queryTransferList(query) {
                api.selectShiZhiTransferInfo(query).then(({data}) => {
                    this.transferInfo = data.list;
                });
            },
            exportInfo() {
                this.queryCondition.startTime = this.queryCondition.time[0];
                this.queryCondition.endTime = this.queryCondition.time[1];
                if (this.queryCondition.startTime == null || this.queryCondition.startTime == "") {
                    this.$message.info("请设置开始时间");
                    return;
                }
                if (this.queryCondition.endTime == null || this.queryCondition.endTime == "") {
                    this.$message.info("请设置结束时间");
                    return;
                }
                api.exportShiZhiTransferInfo(this.queryCondition).then(response => {
                    const fileName = "市值账户转账记录信息表.xlsx";
                    const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
                    if ('download' in document.createElement('a')) {
                        const link = document.createElement('a');
                        link.download = fileName;
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                    } else {
                        navigator.msSaveBlob(blob, fileName);
                    }
                })
            },
            getNowTime() {
                let now = new Date();
                let year = now.getFullYear(); //得到年份
                let month = now.getMonth(); //得到月份
                let date = now.getDate(); //得到日期
                let nextDay = date + 1;
                month = month + 1;
                month = month.toString().padStart(2, "0");
                date = date.toString().padStart(2, "0");
                nextDay = nextDay.toString().padStart(2, "0");
                let currDate = `${year}-${month}-${date} 00:00:00`;
                let nextDate = `${year}-${month}-${nextDay} 00:00:00`;
                this.queryCondition.time = [new Date(currDate), new Date(nextDate)];
            }
        },
        created() {
            this.getNowTime();
            this.submitQuery();
        }
    }
</script>

<style scoped>

</style>
